var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "highlightsNextButton" }, [
    _c("div", { staticClass: "flex flex--center flex--spaceBetween" }, [
      _c("p", [_vm._v(_vm._s(_vm.getNextChartTitle))]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "highlightsNextButton__circle flex--shrink0",
          class: { disabled: _vm.isDisabled },
          attrs: {
            "aria-label": "next chart",
            disabled: _vm.isDisabled,
            "data-gtm": `xmo__highlightsChart--${_vm.getNextChartTitle}`,
            type: "button",
          },
          on: { click: _vm.setCurrentChart },
        },
        [
          _c(
            "svg",
            {
              staticClass: "highlightsNextButton__circle--svgIcon",
              attrs: { height: "18", width: "18", "aria-hidden": "true" },
            },
            [_c("use", { attrs: { "xlink:href": "#iconChevronRightBold" } })]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }